import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchBlendedTimeseriesV2 } from '../../api/timeseriesApi';
import { fetchPortfolioSimulations } from '../../api/analyticsApi';
import usePathHelpers from "./usePathHelpers";

export const usePaths = (portfolios) => {
  const dispatch = useDispatch();
  const [hasFetchedBlended, setHasFetchedBlended] = useState(false);
  const [hasFetchedSimulations, setHasFetchedSimulations] = useState(false);
  const [timeseriesError, setTimeseriesError] = useState(null);
  const [simulationsError, setSimulationsError] = useState(null);
  const { mergedTickerData } = usePathHelpers(portfolios);

  // Handle blended timeseries fetch
  useEffect(() => {
    const shouldFetchData = portfolios.length > 0;

    if (shouldFetchData && !hasFetchedBlended) {
      const mapping = portfolios.map(({ id, weight }) => ({
        k: id,
        v: weight,
      }));

      dispatch(fetchBlendedTimeseriesV2({ mapping }))
        .unwrap()
        .then(() => {
          setHasFetchedBlended(true);
        })
        .catch((error) => {
          setTimeseriesError(error);
        });
    }
  }, [hasFetchedBlended, portfolios, dispatch]);

  // Handle portfolio simulations fetch
  useEffect(() => {
    const shouldFetchData = portfolios.length > 0;
    const tickersList = mergedTickerData.filter(x => x.wgt > 0);

    if (shouldFetchData && !hasFetchedSimulations && tickersList.length > 0) {
      dispatch(fetchPortfolioSimulations({
        symbols: tickersList.map(x => x.symbol),
        weights: tickersList.map(m => m.wgt),
        startDate: '2021-01-01',
        nPaths: 1000,
        freq: 'm',
        initialCapital: 100000,
        nYears: 30
      }))
        .unwrap()
        .then(() => {
          setHasFetchedSimulations(true);
        })
        .catch((error) => {
          setSimulationsError(error);
        });
    }
  }, [hasFetchedSimulations, portfolios, mergedTickerData, dispatch]);

  return {
    hasFetchedBlended,
    hasFetchedSimulations,
    timeseriesError,
    simulationsError,
    resetFetch: () => {
      setHasFetchedBlended(false);
      setHasFetchedSimulations(false);
    }
  };
};